"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _react = _interopRequireWildcard(require("react"));

var _Stack = require("./Stack");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ContentstackPreview = props => {
  const {
    WrappedComponent,
    data,
    pageContext: {
      locale,
      uid
    },
    contentType
  } = props;
  const [currentData, setCurrentData] = (0, _react.useState)(data);
  (0, _react.useEffect)(() => {
    const updateData = async () => {
      const query = _Stack.Stack.ContentType(contentType).Entry(uid).language(locale); // based on getGatsbyDataFormat: https://github.com/contentstack/live-preview-sdk/blob/0da5d451f668694ad93b39b45e46d45a54e52826/src/contentstack-live-preview-HOC.ts#L102


      const fetchedData = await query.toJSON().fetch();
      const dataTitle = (0, _camelCase.default)(`contentstack_${contentType}`);
      const newData = {
        [dataTitle]: fetchedData
      };
      setCurrentData({ ...data,
        newData
      });
    };

    if (process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW === 'true') (0, _Stack.onEntryChange)(updateData);
  }, [data, uid, locale, contentType]);
  return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
    data: currentData
  }));
};

var _default = ContentstackPreview;
exports.default = _default;